/** True for Vite shell tags that must survive before hydrateRoot. */
export function isViteShellHeadElement(element: Element): boolean {
	if (element.tagName === "META") {
		return (
			element.hasAttribute("charset") ||
			element.getAttribute("name") === "viewport"
		);
	}

	if (element.tagName === "SCRIPT") {
		return (
			element.getAttribute("type") === "module" && element.hasAttribute("src")
		);
	}

	if (element.tagName === "LINK") {
		const rel = element.getAttribute("rel");
		if (rel === "modulepreload") {
			return true;
		}
		// Vite CSS uses crossorigin; route HeadContent stylesheets do not.
		if (rel === "stylesheet" && element.hasAttribute("crossorigin")) {
			return true;
		}
	}

	return false;
}

/**
 * Remove prerendered TanStack head tags before hydration.
 * Static tags live outside React's tree; HeadContent hoists duplicates otherwise.
 */
export function clearRouterManagedHeadTags(
	head: ParentNode = document.head,
): void {
	for (const element of [...head.children]) {
		if (!isViteShellHeadElement(element)) {
			element.remove();
		}
	}
}
